export default {
  width: 32,
  height: 32,
  svg: `<circle cx="16" cy="16" r="14" stroke-width="2"/>`,
  stroke: true,
  fill: false
}
